import { injectedEnvironment } from './injected-env';
export const isTest = process.env.NODE_ENV === 'test';

export const Environment = {
    BACKEND_BASE_URL:
        injectedEnvironment['REACT_APP_BACKEND_BASE_URL'] ??
        process.env.REACT_APP_BACKEND_BASE_URL,
    PURPLE_COMPANY_URL: definedOrThrow('REACT_APP_PURPLE_COMPANY_URL'),
    isTest: process.env.NODE_ENV === 'test',
};

function definedOrThrow(variableName: string): string {
    const value =
        injectedEnvironment[variableName] ?? process.env[variableName];
    if (!value) {
        throw new Error(
            `Missing environment variable process.env.${variableName}, you need to provide it for the application to run.`,
        );
    }
    return value;
}
